export class GalleryService {
  constructor(httpClient) {
    this.httpClient = httpClient;
    this.cachedPaths = {};
  }

  clearCache() {
    Object.keys(this.cachedPaths).forEach((path) => {
      delete this.cachedPaths[path];
    });
  }

  async getSearch(url) {
    let searchData = null;
    try {
      if (this.cachedPaths[url]) {
        searchData = this.cachedPaths[url];
      } else {
        const response = await this.httpClient.get(url, {
          headers: { Accept: 'application/json' },
        });
        searchData = response.data;
        if (searchData.redirect?.path) {
          window.location.href = new URL(
            searchData.redirect.path,
            window.location.origin
          ).href;
        }
        this.cachedPaths[url] = searchData;
      }
    } catch (e) {
      if (e.response?.status === 410 && e.response?.data?.redirectPath) {
        // Navigate to the search path and render the 410 page
        window.location.href = e.response.data.redirectPath;
      }
      return null;
    }
    return searchData;
  }

  async search(url, pushState = true) {
    const searchData = await this.getSearch(url);

    if (searchData) {
      // Only update history if the request was successful
      if (pushState) {
        window.history.pushState(null, null, url);
      }

      if (searchData.trackingData) {
        window.tracking_data = searchData.trackingData;
      }
    }

    return searchData;
  }
}

// Legacy API for backward compatibility with Redux actions

let legacyService = null;

const getLegacyService = () => {
  if (!legacyService) {
    // Import axios here to avoid circular dependencies
    // eslint-disable-next-line global-require
    const axios = require('axios').default;
    legacyService = new GalleryService(axios);
  }
  return legacyService;
};

export async function getSearch(url) {
  return getLegacyService().getSearch(url);
}

export async function search(url, pushState = true) {
  return getLegacyService().search(url, pushState);
}

export function clearCache() {
  getLegacyService().clearCache();
}

export default GalleryService;
